import React from "react";
import "./App.css";
import Home from "./pages/home";
import Career from "./pages/career";
import { BrowserRouter as Router, Route } from "react-router-dom";
import Gaming from "./pages/gaming";
import Header from "./pages/components/header";
import Experiences from "./pages/experiences";

function App() {
  return (
    <Router>
      <div>
        <Header/>
        <Route path="/" exact component={Home} />
        {/* <Route path="/career" exact component={Career} /> */}
        <Route path="/gaming" exact component={Gaming} />
        <Route path="/collections" exact component={Experiences} />
      </div>
    </Router>
  );
}

export default App;
